import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getSubMenu = () => {
  try {
    const response = privateAxiosIntance.get(protectedRoutes.subMenu);
    return response;
  } catch (error) {
    throw error;
  }
};
